// extracted by mini-css-extract-plugin
export default {"container":"TimeOfDay_container__tuydH","group-container":"TimeOfDay_group-container__8eSIQ"};